import { AddToMarketListButton } from "@faire/retailer-visitor-shared/components/Events/AddToMarketListButton/AddToMarketListButton";
import { IAddToMarketListButtonVariant } from "@faire/retailer-visitor-shared/components/Events/AddToMarketListButton/AddToMarketListButton.props";
import { useMyMarketList } from "@faire/retailer-visitor-shared/features/FaireMarkets/PromotionsHub/useMyMarketList";
import { useStrictLocalization } from "@faire/web/common/localization";
import { trackBrandTileMarketListBrandTileAddActionCategoryClick } from "@faire/web-api--source/events/brandTile/actionCategoryClick/marketListBrandTileAdd";
import * as React from "react";

interface IProps {
  brandToken: string | undefined;
  className?: string;
  page?: "UNSPECIFIED" | "MARKET_LIST" | "MARKET_HUB";
}

export const MarketListButton: React.FC<IProps> = ({
  brandToken,
  className,
  page = "UNSPECIFIED",
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { deleteBrandFromList, addBrandToList, boardItemsIsAdded } =
    useMyMarketList();

  const inMarketList =
    (brandToken ? boardItemsIsAdded[brandToken] : false) ?? false;
  const handleClick = async () => {
    trackBrandTileMarketListBrandTileAddActionCategoryClick(
      brandToken ?? "",
      inMarketList ? "DELETE" : "ADD",
      page
    );
    await (inMarketList
      ? deleteBrandFromList(brandToken)
      : addBrandToList(brandToken));
  };

  return (
    <AddToMarketListButton
      className={className}
      addText={strictLocalize({
        defaultMessage: "Add to list",
        description: {
          text: "Button text to add brand from the market list for the retailer.",
        },
      })}
      addedText={strictLocalize({
        defaultMessage: "On my list",
        description: {
          text: "Button text for a brand that's added to the market list for the retailer.",
        },
      })}
      removeText={strictLocalize({
        defaultMessage: "Remove",
        description: {
          text: "Button text to remove brand from the market list for the retailer.",
        },
      })}
      variant={
        inMarketList
          ? IAddToMarketListButtonVariant.ADDED
          : IAddToMarketListButtonVariant.DEFAULT
      }
      onClick={handleClick}
      isLoading={false}
    />
  );
};
